import { default as i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { load } from 'react-cookies';
import { Locale } from './utils';
import { localesResources } from './utils/locales';
import { axiosLanguageUpdater } from './api/axios';

export const i18next = i18n.createInstance();

export const i18Next = (): any =>
  i18next
    .use(initReactI18next)
    .init({
      fallbackLng: [Locale.US, Locale.RO],
      lng: load('localization') || load('locale') || Locale.RO,
      resources: localesResources
    })
    .then(() => {
      axiosLanguageUpdater(i18next.language);
      i18next.on('languageChanged', axiosLanguageUpdater);
    });
